import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const GUIDE_URL = `${API}/guida.pdf`;

export const api = axios.create({ baseURL: API });

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/a9fdf011-57a6-4113-afd4-3254644b33e5/images/0029c6460fb1a970695f6262483f258a24ac3bb4132c6df7425968b3226ffe01.jpeg",
  portrait: "https://static.prod-images.emergentagent.com/jobs/a9fdf011-57a6-4113-afd4-3254644b33e5/images/627b0953371525c260e16dcfb36a7addb848b40bbfe5226c916a40ea353fec8c.jpeg",
  food: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  training: "https://customer-assets-lqy194kg.emergentagent.net/job_fitness-donne-italia--9uw2heft/artifacts/3491c56c03203017_IMG_2461.webp",
};
